// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoItem-space1-AG87z {
	margin-bottom: 6px !important;
}

.NoItem-space2-kGU9a {
	margin-bottom: 12px !important;
}

.NoItem-space3-Qfglb {
	margin-bottom: 18px !important;
}

.NoItem-space4-Zg0SQ {
	margin-bottom: 24px !important;
}

.NoItem-space5-lSLKM {
	margin-bottom: 30px !important;
}

.NoItem-space6-ZpbTd {
	margin-bottom: 36px !important;
}

.NoItem-space7-RhTLG {
	margin-bottom: 42px !important;
}

.NoItem-spaceTop8-SQn3Y {
	margin-bottom: 48px !important;
}

.NoItem-spaceTop1-u0M3T {
	margin-top: 6px !important;
}

.NoItem-spaceTop2-Y1Asi {
	margin-top: 12px !important;
}

.NoItem-spaceTop3-sf_O2 {
	margin-top: 18px !important;
}

.NoItem-spaceTop4-cyr_S {
	margin-top: 24px !important;
}

.NoItem-spaceTop5-nJXvF {
	margin-top: 30px !important;
}

.NoItem-spaceTop6-kCNBa {
	margin-top: 36px !important;
}

.NoItem-spaceTop7-eFYSx {
	margin-top: 42px !important;
}

.NoItem-spaceTop8-SQn3Y {
	margin-top: 48px !important;
}

.NoItem-noMargin-IdC9_ {
	margin: 0px !important;
}

.NoItem-padding1-DgPot {
	padding-bottom: 6px !important;
}

.NoItem-padding2-FGmca {
	padding-bottom: 12px !important;
}

.NoItem-padding3-hW0NB {
	padding-bottom: 18px !important;
}

.NoItem-padding4-utUbE {
	padding-bottom: 24px !important;
}

.NoItem-padding5-T5B33 {
	padding-bottom: 30px !important;
}

.NoItem-padding6-HXpm0 {
	padding-bottom: 36px !important;
}

.NoItem-padding7-DYqpx {
	padding-bottom: 42px !important;
}

.NoItem-paddingTop1-RN2Te {
	padding-top: 6px !important;
}

.NoItem-paddingTop2-znQGj {
	padding-top: 12px !important;
}

.NoItem-paddingTop3-P_idC {
	padding-top: 18px !important;
}

.NoItem-paddingTop4-IV9Ms {
	padding-top: 24px !important;
}

.NoItem-paddingTop5-BRG80 {
	padding-top: 30px !important;
}

.NoItem-paddingTop6-vVgwW {
	padding-top: 36px !important;
}

.NoItem-paddingTop7-j2DLf {
	padding-top: 42px !important;
}

.NoItem-noPadding-tjsx4 {
	padding: 0px !important;
}

.NoItem-textBold-pVe6C {
	font-weight: 500 !important;
}

.NoItem-textBolder-rrvXy {
	font-weight: 700 !important;
}

.NoItem-textNormal-IptMD {
	font-weight: normal !important;
}

.NoItem-spaceBottom20-S2kcY {
	margin-bottom: 20px;
}

.NoItem-spaceBottom10-t4ndX {
	margin-bottom: 10px;
}

.NoItem-marginNone-fZOEP {
	margin: 0;
}

.NoItem-spaceBottom15-ZaMrM {
	margin-bottom: 15px;
}

.NoItem-marginTopNone-xhjZq {
	margin-top: 0;
}

.NoItem-spaceTop11-E6PGs {
	margin-top: 11px;
}

.NoItem-spaceTop21-qhcA8 {
	margin-top: 21px;
}

.NoItem-spaceTop20-v5HW9 {
	margin-top: 20px;
}

.NoItem-spaceTop10-LGtdd {
	margin-top: 10px;
}

/*New Design Text Colors */

.NoItem-textDarkBlue-Bp8Op {
	color: rgb(20, 39, 94) !important;
}

.NoItem-textLightBlue-feeqJ {
	color: rgb(57, 87, 106) !important;
}

.NoItem-textLightSandleGreen-lZT4W {
	color: rgb(76, 86, 41) !important;
}

.NoItem-textLightBrown-V6Uzm {
	color: rgb(115, 79, 33) !important;
}

.NoItem-textMediumMaroon-b3nHr {
	color: rgb(87, 37, 51) !important;
}

.NoItem-textBrown-OjArF {
	color: rgb(160, 47, 24) !important;
}

.NoItem-textMaroon-nJvy6 {
	color: rgb(155, 49, 67) !important;
}

.NoItem-textDarkBrown-vJM8o {
	color: rgb(83, 18, 16) !important;
}

.NoItem-textMediumBrown-ZeW7y {
	color: rgb(142, 28, 10) !important;
}

.NoItem-textSkyBlue-E918V {
	color: rgb(37, 117, 141) !important;
}

.NoItem-textGray-JWshA {
	color: rgb(77, 65, 51) !important;
}

.NoItem-textCenter-h3zgP {
  text-align: center;
}

.NoItem-addNewBtn-ldsf3 {
  padding: 13px 15px;
  margin-top: 30px;
  display: inline-block;
}

.NoItem-noListSubHeading-E8zu0 {
  color: var(--secondary-foreground);
  margin: 20px auto;
  max-width: 412px;

}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Reservation/NoItem/NoItem.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;;AAElB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../helpers.css';\n\n.textCenter {\n  text-align: center;\n}\n\n.addNewBtn {\n  padding: 13px 15px;\n  margin-top: 30px;\n  display: inline-block;\n}\n\n.noListSubHeading {\n  color: var(--secondary-foreground);\n  margin: 20px auto;\n  max-width: 412px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `NoItem-space1-AG87z`,
	"space2": `NoItem-space2-kGU9a`,
	"space3": `NoItem-space3-Qfglb`,
	"space4": `NoItem-space4-Zg0SQ`,
	"space5": `NoItem-space5-lSLKM`,
	"space6": `NoItem-space6-ZpbTd`,
	"space7": `NoItem-space7-RhTLG`,
	"spaceTop8": `NoItem-spaceTop8-SQn3Y`,
	"spaceTop1": `NoItem-spaceTop1-u0M3T`,
	"spaceTop2": `NoItem-spaceTop2-Y1Asi`,
	"spaceTop3": `NoItem-spaceTop3-sf_O2`,
	"spaceTop4": `NoItem-spaceTop4-cyr_S`,
	"spaceTop5": `NoItem-spaceTop5-nJXvF`,
	"spaceTop6": `NoItem-spaceTop6-kCNBa`,
	"spaceTop7": `NoItem-spaceTop7-eFYSx`,
	"noMargin": `NoItem-noMargin-IdC9_`,
	"padding1": `NoItem-padding1-DgPot`,
	"padding2": `NoItem-padding2-FGmca`,
	"padding3": `NoItem-padding3-hW0NB`,
	"padding4": `NoItem-padding4-utUbE`,
	"padding5": `NoItem-padding5-T5B33`,
	"padding6": `NoItem-padding6-HXpm0`,
	"padding7": `NoItem-padding7-DYqpx`,
	"paddingTop1": `NoItem-paddingTop1-RN2Te`,
	"paddingTop2": `NoItem-paddingTop2-znQGj`,
	"paddingTop3": `NoItem-paddingTop3-P_idC`,
	"paddingTop4": `NoItem-paddingTop4-IV9Ms`,
	"paddingTop5": `NoItem-paddingTop5-BRG80`,
	"paddingTop6": `NoItem-paddingTop6-vVgwW`,
	"paddingTop7": `NoItem-paddingTop7-j2DLf`,
	"noPadding": `NoItem-noPadding-tjsx4`,
	"textBold": `NoItem-textBold-pVe6C`,
	"textBolder": `NoItem-textBolder-rrvXy`,
	"textNormal": `NoItem-textNormal-IptMD`,
	"spaceBottom20": `NoItem-spaceBottom20-S2kcY`,
	"spaceBottom10": `NoItem-spaceBottom10-t4ndX`,
	"marginNone": `NoItem-marginNone-fZOEP`,
	"spaceBottom15": `NoItem-spaceBottom15-ZaMrM`,
	"marginTopNone": `NoItem-marginTopNone-xhjZq`,
	"spaceTop11": `NoItem-spaceTop11-E6PGs`,
	"spaceTop21": `NoItem-spaceTop21-qhcA8`,
	"spaceTop20": `NoItem-spaceTop20-v5HW9`,
	"spaceTop10": `NoItem-spaceTop10-LGtdd`,
	"textDarkBlue": `NoItem-textDarkBlue-Bp8Op`,
	"textLightBlue": `NoItem-textLightBlue-feeqJ`,
	"textLightSandleGreen": `NoItem-textLightSandleGreen-lZT4W`,
	"textLightBrown": `NoItem-textLightBrown-V6Uzm`,
	"textMediumMaroon": `NoItem-textMediumMaroon-b3nHr`,
	"textBrown": `NoItem-textBrown-OjArF`,
	"textMaroon": `NoItem-textMaroon-nJvy6`,
	"textDarkBrown": `NoItem-textDarkBrown-vJM8o`,
	"textMediumBrown": `NoItem-textMediumBrown-ZeW7y`,
	"textSkyBlue": `NoItem-textSkyBlue-E918V`,
	"textGray": `NoItem-textGray-JWshA`,
	"textCenter": `NoItem-textCenter-h3zgP`,
	"addNewBtn": `NoItem-addNewBtn-ldsf3`,
	"noListSubHeading": `NoItem-noListSubHeading-E8zu0`
};
module.exports = ___CSS_LOADER_EXPORT___;
